type Availability = Record<string, Record<string, string[]>>;

//  Input (from SurveyJS):
//  {
//    "08:00-10:00": { "Monday": ["Available"], "Monday2": ["Available"] },
//    "10:00-12:00": { "Tuesday2": ["Available"], "Friday": ["Available"] }
//  }

//  Note:
//  - Days ending with "2" mean next week (e.g., "Monday2" - next Monday).
//  - Regular days are this week.

//  Example Output:
//  <b>Monday (this week)</b>: 08:00-10:00<br>
//  <b>Tuesday (next week)</b>: 10:00-12:00

const CustomizePatientAvailability = (val: Availability) => {
  if (!val || typeof val !== 'object') return '';

  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  //Step 1: Convert time-based structure to day-based structure
  const dayToTimes: Record<string, string[]> = {};

  for (const [timeSlot, daysObj] of Object.entries(val)) {
    if (!daysObj || typeof daysObj !== 'object') continue;

    for (const [day, arr] of Object.entries(daysObj)) {
      if (!arr?.length) continue;
      if (!dayToTimes[day]) dayToTimes[day] = [];
      dayToTimes[day].push(timeSlot);
    }
  }

  //Step 2: Sort days by week (this → next) and weekday order
  const sortedDays = Object.keys(dayToTimes).sort((a, b) => {
    const baseA = a.replace('2', '');
    const baseB = b.replace('2', '');
    const weekA = a.endsWith('2') ? 1 : 0;
    const weekB = b.endsWith('2') ? 1 : 0;
    const dayIndexA = dayOrder.indexOf(baseA);
    const dayIndexB = dayOrder.indexOf(baseB);
    return weekA - weekB || dayIndexA - dayIndexB;
  });

  //Step 3: Add week labels
  const addWeekLabel = (day: string) =>
    day.endsWith('2') ? `${day.replace('2', '')} (next week)` : `${day} (this week)`;

  //Step 4: Build formatted HTML output
  const formattedAvailability = sortedDays
    .map((day) => `<b>${addWeekLabel(day)}</b>: ${dayToTimes[day].join(' | ')}`)
    .join('<br>');

  return formattedAvailability;
};

export default CustomizePatientAvailability;
